"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssociateTPSLOrder = exports.useTPSLInfo = exports.useTPSLList = exports.refreshTPSLList = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TriggersApi_1 = require("../../apis/TriggersApi");
const trade_utils_lib_1 = require("trade_utils_lib");
const Trade_1 = require("../Trade");
const createPublish = ({ accountType, subject }) => {
    return (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000), subject).pipe((0, operators_1.switchMap)(() => {
        // NO CACHED
        return (0, TriggersApi_1.queryActiveTriggers)({ accountType, trigger_function: "POSITION", limit: 500 }).pipe((0, operators_1.map)((res) => {
            const tpMap = new Map();
            const slMap = new Map();
            res.forEach((item) => {
                const { symbol } = item;
                const type = Trade_1.TPSLUtils.getOrderTPSLMode(item);
                if (type === "tp") {
                    tpMap.set(symbol, item);
                }
                else {
                    slMap.set(symbol, item);
                }
            });
            const info = {
                list: res,
                tpMap,
                slMap,
            };
            return info;
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)(null);
        }), (0, operators_1.filter)((res) => !!res), (0, operators_1.map)((res) => res));
    }), (0, operators_1.publishBehavior)({
        list: [],
        tpMap: new Map(),
        slMap: new Map(),
    }), (0, operators_1.refCount)());
};
const triggerSubject = new rxjs_1.Subject();
const tpSlPublish$ = createPublish({ accountType: trade_utils_lib_1.AccountTradeType.trader, subject: triggerSubject });
/**刷新止盈止损的列表 */
function refreshTPSLList() {
    triggerSubject.next(Date.now());
}
exports.refreshTPSLList = refreshTPSLList;
function useTPSLList(props) {
    const [orders, setOrders] = (0, react_1.useState)([]);
    const { active = true, curSymbol = "", activeSymbol = "" } = props;
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = tpSlPublish$.subscribe((res) => {
            setOrders(res.list);
        }, () => { });
        return () => sub.unsubscribe();
    }, [active]);
    const filteredList = (0, react_1.useMemo)(() => {
        if (activeSymbol) {
            return orders.filter((it) => it.symbol === activeSymbol);
        }
        if (curSymbol) {
            // do sorting
            const sortedList = [];
            orders.forEach((it) => {
                if (it.symbol === curSymbol) {
                    sortedList.unshift(it);
                }
                else {
                    sortedList.push(it);
                }
            });
            return sortedList;
        }
        return orders;
    }, [activeSymbol, curSymbol, orders]);
    return { source: orders, filteredList };
}
exports.useTPSLList = useTPSLList;
function useTPSLInfo(active = true) {
    const [tpslInfo, setTpslInfo] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = tpSlPublish$.subscribe((res) => {
            setTpslInfo(res);
        }, () => { });
        return () => sub.unsubscribe();
    }, [active]);
    return tpslInfo;
}
exports.useTPSLInfo = useTPSLInfo;
function useAssociateTPSLOrder(symbol, active = true) {
    const info = useTPSLInfo(active);
    const { tpMap, slMap } = info || {};
    return (0, react_1.useMemo)(() => [tpMap === null || tpMap === void 0 ? void 0 : tpMap.get(symbol), slMap === null || slMap === void 0 ? void 0 : slMap.get(symbol)], [symbol, slMap, tpMap]);
}
exports.useAssociateTPSLOrder = useAssociateTPSLOrder;
